export class DatabaseAsleepError extends Error {
  constructor(message) {
    super(message);
  }
}
